import { useMemo } from 'react';
import { CR_COLORS } from '../../utils/theme';
import type { ReactNode, CSSProperties, HTMLAttributes } from 'react';

export type TextProps = {
  children?: ReactNode | null;
  fontWeight?: CSSProperties['fontWeight'];
  color?: string;
  crColor?: keyof typeof CR_COLORS;
  fontSize?: number;
  span?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export /* @__PURE__*/ const Text = ({
  children,
  fontWeight = 500,
  color,
  fontSize,
  span,
  style,
  crColor,
  ...restProps
}: TextProps) => {
  const Wrapper = span ? 'span' : 'div';
  const _color = useMemo(() => {
    return crColor ? CR_COLORS[crColor] ?? color : color;
  }, [crColor, color]);
  return (
    <Wrapper
      style={{
        fontWeight,
        color: _color,
        fontSize,
        ...style,
      }}
      {...restProps}
    >
      {children}
    </Wrapper>
  );
};
